<template>
  <section class="odm-offer-section">
    <div class="odm-offer-inner">
      <h2 class="odm-section-title">{{ t('odm.serviceDeliver.sectionTitle') }}</h2>
      <div class="odm-offer-desc">{{ t('odm.serviceDeliver.desc') }}</div>
      <div class="odm-offer-flex">
        <div class="odm-offer-left">
          <div class="odm-offer-card odm-offer-card-lg">
            <img src="../../assets/solution/offer01.jpg" alt="定向研发" class="odm-offer-img" />
            <div class="odm-offer-content">
              <div class="odm-offer-content-bg">
                <div class="odm-offer-title odm-offer-line">{{ serviceDeliverCards[0].title }}</div>
                <div class="odm-offer-text" v-html="serviceDeliverCards[0].text"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="odm-offer-right">
          <div class="odm-offer-card odm-offer-card-sm">
            <img src="../../assets/solution/offer02.jpg" alt="灵活制造" class="odm-offer-img" />
            <div class="odm-offer-content">
              <div class="odm-offer-content-bg">
                <div class="odm-offer-title">{{ serviceDeliverCards[1].title }}</div>
                <div class="odm-offer-text" v-html="serviceDeliverCards[1].text"></div>
              </div>
            </div>
          </div>
          <div class="odm-offer-card odm-offer-card-get">
            <img src="../../assets/solution/offer03.jpg" alt="申请专利" class="odm-offer-img" />
            <div class="odm-offer-content">
              <div class="odm-offer-content-bg">
                <div class="odm-offer-title">{{ serviceDeliverCards[2].title }}</div>
                <div class="odm-offer-text" v-html="serviceDeliverCards[2].text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t, tm } = useI18n()
// 使用tm获取国际化数组
const serviceDeliverCards = computed(() => tm('odm.serviceDeliver.cards'))
</script>

<style scoped>
.odm-offer-section {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  background-image: url('../../assets/solution/bg_deliver.png');
  background-repeat: no-repeat;
  background-size: contain;
  /* 确保图片完整显示 */
  background-position: center;
  /* 图片居中对齐 */
  margin-top: 20px;
  margin-bottom: 50px;
}

.odm-offer-inner {
  position: relative;
  width: 80%;
  margin: 0 auto;
  padding: 0 16px;
}

.odm-section-title {
  text-align: center;
  /* 需要适配 */
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
  position: relative;
}

.odm-offer-desc {
  text-align: center;
  margin-bottom: 80px;
  /* 需要适配 */
  font-size: 1.1rem;
}

.odm-offer-flex {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
}

.odm-offer-left,
.odm-offer-right {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.odm-offer-left {
  flex: 1;
}

.odm-offer-right {
  flex: 1;
  justify-content: space-between;
}

.odm-offer-card,
.odm-offer-card-lg,
.odm-offer-card-sm,
.odm-offer-card-get {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  border-radius: 2px;
  overflow: hidden;
}

.odm-offer-card-lg {
  height: 100%;
}

.odm-offer-card-sm,
.odm-offer-card-get {
  height: calc(50% - 16px);
}

.odm-offer-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.odm-offer-content {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  pointer-events: none;
  overflow: auto;
  word-break: break-all;
  margin: 5% 5%;
  padding: 10px;
}

.odm-offer-content-bg {
  background-image: url("../../assets/solution/odm_title.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 10px;
  padding-left: 25px;
  padding-top: 10px;
  padding-bottom: 30px;
  border-radius: 6px;
}

.odm-offer-title {
  position: relative;
  font-size: 2rem;
  /* font-weight: bold; */
  /* color: black; */
  margin-bottom: 2%;
}

.odm-offer-line::after {
  content: '';
  display: block;
  width: 60px;
  height: 2px;
  background: rgb(71, 69, 69);
  margin-top: 8px;
}

.odm-offer-text {
  /* color: #fff; */
  font-size: 1.08rem;
  line-height: 1.7;
}




/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .odm-section-title {
    font-size: 2.4rem;
  }

  .odm-offer-title {
    font-size: 1.7rem;
  }

  .odm-offer-desc {
    font-size: 1.2rem;
    margin-bottom: 80px;
  }

  .odm-offer-text {
    font-size: 1rem;
    line-height: 1.5;
  }

  .odm-offer-inner {
    position: relative;
    width: 82%;
    margin: 0 auto;
    padding: 0 16px;
  }

  .odm-offer-right {
    gap: 30px;
  }

  .odm-offer-content {
    margin: 5% 5%;
  }

  .odm-offer-line::after {
    width: 50px;
  }

  .odm-offer-section {
    margin-bottom: 50px;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .odm-section-title {
    font-size: 2.2rem;
  }

  .odm-offer-title {
    font-size: 1.4rem;
  }

  .odm-offer-desc {
    font-size: 1.1rem;
    margin-bottom: 70px;
  }

  .odm-offer-text {
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .odm-offer-inner {
    position: relative;
    width: 85%;
    margin: 0 auto;
    padding: 0 16px;
  }

  .odm-offer-right {
    gap: 20px;
  }

  .odm-offer-content {
    margin: 1% 1%;
  }

  .odm-offer-line::after {
    width: 40px;
  }

  .odm-offer-section {
    margin-bottom: 40px;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .odm-section-title {
    font-size: 2rem;
  }

  .odm-offer-title {
    font-size: 1.1rem;
  }

  .odm-offer-desc {
    font-size: 1rem;
    margin-bottom: 60px;
  }

  .odm-offer-text {
    font-size: 0.8rem;
    line-height: 1.3;
  }

  .odm-offer-inner {
    position: relative;
    width: 90%;
    margin: 0 auto;
    padding: 0 16px;
  }

  .odm-offer-right {
    gap: 20px;
  }

  .odm-offer-content {
    margin: 1% 1%;
  }

  .odm-offer-line::after {
    width: 30px;
  }

  .odm-offer-section {
    margin-bottom: 30px;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {

  /* 调整弹性容器方向为纵向 */
  .odm-offer-flex {
    flex-direction: column;
    gap: 15px;
    /* 纵向间距 */
  }

  /* 左边和右边容器宽度占满 */
  .odm-offer-left,
  .odm-offer-right {
    flex: 1 1 auto;
    /* 允许子元素自动扩展 */
    width: 100%;
    /* 强制宽度占满 */
  }

  /* 左边大卡片改为两行排列（通过高度自适应实现） */
  .odm-offer-card-lg {
    height: auto;
    /* 高度随内容自适应 */
    min-height: 80px;
  }

  /* 其他原有样式保持 */
  .odm-section-title {
    font-size: 1.8rem;
  }

  .odm-offer-title {
    font-size: 0.9rem;
  }

  .odm-offer-desc {
    font-size: 0.9rem;
    margin-bottom: 50px;
  }

  .odm-offer-text {
    font-size: 0.7rem;
    line-height: 1.4;
  }

  .odm-offer-inner {
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
  }

  .odm-offer-right {
    gap: 20px;
  }

  .odm-offer-content {
    margin: 0;
  }

  .odm-offer-section {
    margin-bottom: 20px;
  }
}
</style>